import Level_1_channel from "../../../assets/group logo/Level_1_Channel.png";
import Level_1_female from "../../../assets/group logo/Level_1_Female.png";
import Level_1_male from "../../../assets/group logo/Level_1_Male.png";

import { faHand } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const tajweed_group_links = {
  4: {
    female_1: "",
    channel_1: "",
  },
};

export const getTajweedGroupLink = (batch, type) => {
  if (tajweed_group_links[batch] && tajweed_group_links[batch][type]) {
    return tajweed_group_links[batch][type];
  } else {
    return "";
  }
};

const TajweedGroupCard = ({ batch, gender, level }) => {
  const imageMap = {
    1: {
      male: Level_1_male,
      female: Level_1_female,
      channel: Level_1_channel,
    },
  };

  if (tajweed_group_links[batch])
    return (
      <div className="p-5 rounded bg-gradient-to-tl from-sky-300">
        <p>
          <span className="text-xl">Join </span>
          <FontAwesomeIcon className="text-blue-600" icon={faHand} fade />
        </p>

        <div className="mt-4 flex justify-around">
          <a
            href={getTajweedGroupLink(batch, `${gender}_${level}`)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div>
              <div>
                <img className="w-20" src={imageMap[level][gender]} alt="" />
              </div>
              <p className="text-center">Class Group</p>
            </div>
          </a>

          <a
            href={getTajweedGroupLink(batch, `channel_${level}`)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div>
              <div>
                <img className="w-20" src={imageMap[level]["channel"]} alt="" />
              </div>
              <p className="text-center">Lecture Notes</p>
            </div>
          </a>
        </div>
      </div>
    );
};

export default TajweedGroupCard;
